import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/auth.context';

/** Пропускает дальше только пользователей с ролью admin, иначе — на /overview. */
const RequireAdmin = () => {
  const { user } = useAuth();

  if (user?.role !== 'admin') {
    return <Navigate to="/overview" replace />;
  }

  return <Outlet />;
};

export default RequireAdmin;
